import { createRequest } from '../../../core/libs/api';
import { RequestConfig } from '../../../core/libs/http-client/types';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/registration',
};

export const signUpRequest = (credentials?: {
  phone: string;
  code?: string;
  password: string;
}) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(credentials),
  });
